/**
 * Alaska: App.js (PWA)
 * Data: Document
 * @version 1.0
 */

document.addEventListener("alpine:init", () => {
    Alpine.data("Document", () => ({
        filename: null,
        url: null,

        async open_document(source) {
            if (!source) return;

            this.filename = source.split("/").pop();
            const redirect_url = `/?action=open_document&controller=documents&filename=${encodeURIComponent(this.filename)}`;

            try {
                Loading.show();

                Alpine.store("modal").open({ document: redirect_url });
                await Alpine.nextTick();
                await Alpine.store("modal").render_document();

                Loading.hide();
            } catch (err) {
                Alpine.store("modal").close();
                console.error("Error rendering PDF", err);
                Loading.hide();
                Alpine.store("overlay").render("error", "Failed to load PDF.");
            }
        },

        close() {
            this.url = null;
            this.filename = null;
        }
    }));
});